import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconReport16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconReport16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M4 2h8a1 1 0 0 1 1 1v10.143a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1M2 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v10.143a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm3.429 1a.5.5 0 0 0 0 1h5.143a.5.5 0 0 0 0-1zm-.5 2.5a.5.5 0 0 1 .5-.5h3.428a.5.5 0 0 1 0 1H5.43a.5.5 0 0 1-.5-.5m2.56 2.819-.348-.338-.348.338-1.69 1.64a.5.5 0 0 0 .696.718l1.342-1.303 1.343 1.303.348.338.348-.338 1.691-1.64a.5.5 0 1 0-.696-.718L8.834 10.62z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconReport16);
